<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj' : 'Dodaj obiekt' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa obiektu*"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex md12>
          <v-layout row wrap>
            <v-flex pr-2 xs12 md6>
              <w-schema :model="$schema.city">
                <v-text-field name="name" label="Miasto" @input="setMarkerDebounced"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md6>
              <w-schema :model="$schema.postalCode">
                <v-text-field name="name" label="Kod Pocztowy" @input="setMarkerDebounced"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.street">
            <v-text-field name="name" label="Ulica" @input="setMarkerDebounced"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex md12>
          <v-layout row wrap>
            <v-flex pr-2 xs12 md6>
              <w-schema :model="$schema.homeNumber">
                <v-text-field name="name" label="Numer budynku"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md6>
              <w-schema :model="$schema.localNumber">
                <v-text-field name="name" label="Numer lokalu"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <map-component
          v-if="show"
          :tilesUrl="tilesUrl"
          :marker="marker"
          :markerDraggable="true"
          :latModel="$schema.lat"
          :lngModel="$schema.lng"
          :zoom="defaultZoom"
          :center="defaultCenter"
        />

        <v-flex class="mb-4" v-if="show">
          <html-editor :schema="$schema.description"></html-editor>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.descriptionShort">
            <v-textarea label="Opis skrócony"></v-textarea>
          </w-schema>
        </v-flex>

        <v-flex v-if="show">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <single-image :schema="$schema.mainImage"></single-image>
            </v-flex>
            <v-flex xs12 md6>
              <images-list :schema="$schema.images"></images-list>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import debounce from 'debounce';
import { WSchema } from '@witkac/vuetify-components';
import { geoResource } from '@witkac/kartamiejska-resources';
import { mapState } from 'vuex';
import MapComponent from '@witkac/osm-map';

import ImagesList from '@/components/forms/ImagesList';
import SingleImage from '@/components/forms/SingleImage';
import HtmlEditor from '@/components/forms/HtmlEditor';
import Modal from '@/components/material/Modal';
import schema from '@/schemas/place.schema';
import { manageMixin } from '@/mixins/manage';
import { config } from '@/utils/config';

const emptyData = () => ({
  name: '',
  description: '',
  city: '',
  postalCode: '',
  street: '',
  homeNumber: '',
  localNumber: '',
  descriptionShort: '',
  images: '',
  mainImage: null,
  lat: '',
  lng: ''
});

// @vuese
// Modal dodawania/edycji obiektu
// @group Partners
export default {
  components: { HtmlEditor, ImagesList, Modal, SingleImage, WSchema, MapComponent },
  mixins: [manageMixin('partners/places', {}, emptyData)],
  schema,
  data() {
    return {
      tilesUrl: config.mapTilesURL
    };
  },
  computed: {
    marker() {
      const { lat, lng, name } = this.$schema.$model;
      if (lat && lng) {
        return { lat, lng, text: name };
      }
    },
    ...mapState({
      stateData: state => state.partners.places.data,
      defaultCenter(state) {
        const { lat, lng } = state.partners.places.data || {};
        const defaultCenterSetting = state.settings.settings.PUBLIC_DEFAULT_CENTER;
        if (lat && lng) {
          return [lat, lng];
        } else if (defaultCenterSetting) {
          return JSON.parse(defaultCenterSetting.value).center;
        }
      },
      defaultZoom(state) {
        const defaultZoomSetting = state.settings.settings.PUBLIC_DEFAULT_MAP_LEVEL;
        if (defaultZoomSetting) {
          return parseInt(defaultZoomSetting.value);
        }
      }
    })
  },
  methods: {
    setMarkerDebounced: debounce(function() {
      this.setMarker();
    }, 500),
    setMarker() {
      const { city, street, postalCode } = this.$schema;
      if (city.$model && street.$model && postalCode.$model) {
        geoResource.search(city.$model, street.$model, postalCode.$model).then(
          result => {
            if (result && result.data.length) {
              const { lat, lon } = result.data[0];
              this.$schema.$setData({ lat, lng: lon });
            }
          },
          err => this.$store.dispatch('notifyError', { title: 'Nie udało się znaleźć lokalizacji' })
        );
      }
    }
  }
};
</script>
